import { render, staticRenderFns } from "./troops.vue?vue&type=template&id=07eed64f&scoped=true&"
import script from "./troops.vue?vue&type=script&lang=js&"
export * from "./troops.vue?vue&type=script&lang=js&"
import style0 from "./troops.vue?vue&type=style&index=0&id=07eed64f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eed64f",
  null
  
)

export default component.exports